/**
 * A functional-programming-inspired type that holds either a success result or
 * an error message (e.g. from an HTTP request). This paradigm is useful
 * because errors that are thrown in JavaScript are necessarily untyped, so if
 * you're expecting a possible error, it is better to return a `Result` than to
 * throw.
 *
 * TODO: Move this functionality into a shared library.
 */
export type Result<T, E> =
  | {
      readonly isError: false;
      readonly value: T;
    }
  | {
      readonly isError: true;
      /** Error is `null` if its code was unknown. */
      readonly error: E | null;
    };

const ok = <T, E>(value: T): Result<T, E> => ({
  isError: false,
  value
});

const error = <T, E>(errorValue: E | null): Result<T, E> => ({
  isError: true,
  error: errorValue
});

export const Result = { ok, error };

export type ModalFragmentProps = {
  closeModal: () => void;
};
